import { useState, useEffect } from 'react';
import { webSocketService } from '../services/websocket';
export const useSubscription = (room) => {
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(!!room); // Only loading if room exists
    useEffect(() => {
        // If no room, don't subscribe and clear data
        if (!room) {
            setData(null);
            setIsLoading(false);
            return;
        }
        // Start with loading state - will be set to false when we get any data (cached or fresh)
        setIsLoading(true);
        // Subscribe for updates (both cached and fresh)
        const callback = (newData) => {
            setData(newData);
            setIsLoading(false); // Hide loading when any data arrives (cached or fresh)
        };
        webSocketService.subscribe(room, callback);
        return () => {
            webSocketService.unsubscribe(room, callback);
        };
    }, [room]);
    // Listen for connection status changes to show loading when reconnecting
    useEffect(() => {
        const unsubscribe = webSocketService.onConnectionStatusChange(() => {
            const connectionStatus = webSocketService.getConnectionStatus();
            // Show loading when connecting/reconnecting (but only if we already have data to show)
            if (connectionStatus === 'connecting' && data) {
                setIsLoading(true);
            }
            // Hide loading when connected (fresh data will arrive soon)
            else if (connectionStatus === 'connected' && data) {
                // Don't immediately hide loading - let fresh data arrival hide it
                // This prevents flicker between "connecting" and "fresh data"
            }
            // Show loading when disconnected (but only if we have data to preserve)
            else if (connectionStatus === 'disconnected' && data) {
                setIsLoading(false); // Keep showing cached data without loading spinner
            }
        });
        return unsubscribe;
    }, [data]);
    return {
        data,
        isLoading,
    };
};
